import { useMemo } from 'react';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import zhHK from 'antd/locale/zh_HK';
import { IntlProvider } from 'react-intl';
import { loadLocale } from '../locale/index.js';

function resolveAntdLocale(localeName) {
    switch (localeName) {
        case 'cn':
            return zhCN;
        case 'hk':
            return zhHK;
        default:
            return enUS;
    }
}

function ShellLocaleRuntime(props) {
    const localeName =
        typeof window === 'undefined'
            ? 'en'
            : window.localStorage.getItem('localeName') || 'en';
    const { locale, message } = useMemo(
        () => loadLocale(localeName),
        [localeName]
    );

    return (
        <IntlProvider locale={locale} messages={message} onError={() => {}}>
            <ConfigProvider locale={resolveAntdLocale(localeName)}>
                {props.children}
            </ConfigProvider>
        </IntlProvider>
    );
}

export default ShellLocaleRuntime;
